module.exports = __webpack_public_path__ + "static/media/(000057).388c588a.jpg";